/** API Core */
export const coreSubscriptionsRoute = 'subscriptions';
export const coreActivateCouponRoute = 'virtual/premiums';
